import React, { useEffect, useRef, useState } from 'react';
import Confetti from 'react-confetti';
import './styles.scss';
const drawSquareShape = (ctx, size) => {
  ctx.beginPath();
  ctx.fillRect(0, 0, size, size);
  ctx.stroke();
  ctx.closePath();
};
export const CongratulationsRunner = ({
  color = '#003e84',
  textColor = '#000',
  firstText,
  secondText,
  header,
  timeout,
  children,
  showCongratulations
}) => {
  const [play, setPlay] = useState(false);
  const timer = useRef(null);
  useEffect(() => {
    if (showCongratulations) {
      timer.current = setTimeout(() => setPlay(true), timeout);
    } else {
      setPlay(false);
    }
    return () => {
      clearTimeout(timer.current);
    };
  }, [timeout, showCongratulations, setPlay]);
  const Congratulations = /*#__PURE__*/React.createElement(React.Fragment, null, header, /*#__PURE__*/React.createElement("div", {
    className: "Congratulations"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "congratulations-title",
    style: {
      color: textColor
    }
  }, /*#__PURE__*/React.createElement("span", null, firstText), /*#__PURE__*/React.createElement("br", null), secondText), /*#__PURE__*/React.createElement("h1", {
    className: "congratulations-title animated",
    style: {
      color: textColor
    }
  }, /*#__PURE__*/React.createElement("span", null, firstText), /*#__PURE__*/React.createElement("br", null), secondText), /*#__PURE__*/React.createElement(Confetti, {
    width: 1920,
    height: 1080,
    colors: [color],
    gravity: 0.3,
    initialVelocityX: 1,
    initialVelocityY: 5,
    numberOfPieces: 50,
    drawShape: ctx => drawSquareShape(ctx, 30)
  })));
  return play && showCongratulations ? Congratulations : children;
};